import React from 'react';
import { Image, Typography } from 'tfc-components';

import howWeWork1 from 'assets/images/aboutUs/howWeWork_1.png';
import howWeWork2 from 'assets/images/aboutUs/howWeWork_2.png';
import howWeWork3 from 'assets/images/aboutUs/howWeWork_3.png';
import howWeWork4 from 'assets/images/aboutUs/howWeWork_4.png';
import Section from 'components/organisms/Section';

interface ITeam {
  image: string,
  title: string,
  description: string
}

/* Fake data */
const data: ITeam[] = [
  { image: howWeWork1, title: 'Explore', description: '– Find real user pain' },
  { image: howWeWork2, title: 'Prototype', description: '– Test fast, with minimal resources' },
  { image: howWeWork3, title: 'Validate', description: '– Launch to market, measure what matters' },
  { image: howWeWork4, title: 'Kill or Scale', description: '– Keep only what works' },
];
const HowWeWork:React.FC = () => (
  <Section>
    <Section.Title>
      How We Work
    </Section.Title>

    <div className="p-about_team_list">
      {data.map((item, index) => (
        <div className="p-about_howWeWork_item" key={`howWeWork-${index.toString()}`}>
          <Image alt={item.title} imgSrc={item.image} ratio={345 / 311} />

          <Typography.Text fontweight="400" extendClasses="f-24x36 p-about_team_description">
            <Typography.Text type="span" fontweight="600" extendClasses="f-24x36 p-about_team_title">
              {item.title}
            </Typography.Text>
            {' '}
            {item.description}
          </Typography.Text>
        </div>
        ))}
    </div>
  </Section>

  );

export default HowWeWork;
